<template>
  <v-card
    class="pa-4"
    :style="cardStyle"
  >
    <div class="d-flex align-center justify-center">
      <v-img
        :src="`/img/${image}`"
        width="80%"
        height="64"
        contain
      ></v-img>
    </div>
    <div class="d-flex align-center my-4">
      <v-spacer></v-spacer>
      <div style="font-size: 16px; font-weight: bold;"> {{ sensorData.lastName }} {{ sensorData.firstName }} </div>
      <v-spacer></v-spacer>
    </div>

    <v-progress-linear
      v-if="isUpdating"
      indeterminate
      color="primary"
      class="my-8"
    ></v-progress-linear>


    <div class="my-4 d-flex">
      <v-spacer></v-spacer>
      <v-btn
        v-if="isSleep"
        color="#EE6190"
        variant="flat"
        rounded
        @click="getUp"
        :disabled="!isStarted || isUpdating"
      >{{ $t('ui.wakeUp') }}</v-btn>
      <v-btn
        v-else
        color="primary"
        variant="flat"
        rounded
        @click="sleepIn"
        :disabled="!isStarted || isUpdating"
      >{{ $t('ui.sleep') }}</v-btn>
      <v-spacer></v-spacer>
    </div>

    <div class="my-4 d-flex" v-if="isAlerting">
      <v-spacer></v-spacer>
      <v-btn
        color="#EE6190"
        variant="outlined"
        rounded
        @click="stopAlert"
      >
        <v-icon>mdi-bell-off</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </div>

    <v-card-actions>
      <div class="sensor-metadata" style="flex: 1;">
        {{ sensorData.temperature || '-' }} ℃
      </div>
      <div class="sensor-metadata" style="flex: 1;">
        {{ sensorData.respiration || '-' }} 拍
      </div>
    </v-card-actions>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { MeResponse, NurseryNapDetailResponse, NurseryNapSensorLatest } from 'chaild-api/lib';
export default defineComponent({
  props: {
    sensorData: {
      type: Object as PropType<NurseryNapSensorLatest>,
      required: true,
    },
    updatingChildId: {
      type: Number,
      required: false,
    },
    alertingChildrenIds: {
      type: Array as PropType<number[]>,
      default: () => [],
    }
  },

  computed: {
    status() {
      if (!this.sensorData.isStart) {
        return 'standby';
      } else if (!this.sensorData.isSleeping) {
        if (
          this.sensorData.isAlert
        ) {
          return 'awake-danger';
        }
        return 'awake';
      } else {
        if (!this.sensorData.posture || this.sensorData.posture === 0) {
          return 'sleep-up';
        }
        if (
          this.sensorData.isAlert
        ) {
          return 'sleep-danger';
        }
        if (this.sensorData.posture <= -1) {
          return 'sleep-right';
        }
        if (this.sensorData.posture >= 1) {
          return 'sleep-left';
        }
        return 'awake';
      }
    },
    isAlerting(): boolean {
      if (this.alertingChildrenIds.indexOf(this.sensorData.childId) >= 0) {
        return true;
      }
      return false;
    },
    isStarted(): boolean {
      return this.sensorData.isStart;
    },
    isSleep(): boolean {
      return this.status.startsWith('sleep');
    },
    isUpdating(): boolean {
      if (this.updatingChildId) {
        return this.sensorData.childId === this.updatingChildId;
      }
      return false;
    },
    image() {
      const status = this.status;
      if (status === 'standby') {
        // return '/awake.png';
        return null;
      }
      if (status.endsWith('danger')) {
        return '/danger.png';
      } else if (status === 'awake') {
        return '/awake.png';
      } else if (status === 'sleep-up') {
        return '/sleep.png';
      } else if (status === 'sleep-right') {
        return '/sleep-right.png';
      } else if (status === 'sleep-left') {
        return '/sleep-left.png';
      }
      return null;
    },
    cardStyle() {
      if (this.status.startsWith('sleep')) {
        return `background-color: #e5f0fc;`
      }
      return null;
    }
  },

  methods: {
    sleepIn() {
      this.$emit('sleepIn');
    },
    getUp() {
      this.$emit('getUp');
    },
    stopAlert() {
      this.$emit('stopAlert', this.sensorData.childId);
    }
  }
})
</script>
<style lang="scss" scoped>
.sensor-metadata {
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  font-weight: bold;
}
</style>